import { Injectable } from '@angular/core';
import { PluginsManager } from 'src/app/managers/plugins.manager';
import { MenuElement } from '../services/menu/models/menu.model';
import { IPlugin } from 'src/app/interfaces/IPlugin';

@Injectable({
  providedIn: 'root'
})
export class PluginsMenuManager {

  public constructor(
    private pluginsManager: PluginsManager
  ) { }

  public setPluginsContainer(menuElements: MenuElement[]): MenuElement {
    const plugins = this.pluginsManager.getAllActivePlugins();
    if (!plugins || plugins.length === 0) return;

    const integracionMenu = menuElements.find((option) => option.textId == "Integracion");
    const pluginsContainer =
    {
      id: 9999,
      text: "<div style='color: black;'>" + "Plugins" + '</div>',
      parentid: integracionMenu.id > 0 ? integracionMenu.id : -1,
      subMenuWidth: '230px',
      value: "",
      textId: "Plugins_container",
      menuOpcionId: 9998
    }
    return pluginsContainer;
  }

  public addPluginMenu(): MenuElement[] {
    const plugins = this.pluginsManager.getAllPlugins()
    const pluginMenus: MenuElement[] = [];

    if (!plugins || plugins.length === 0) return pluginMenus;

    const parentId = 9999;

    plugins.forEach((plugin: IPlugin) => {
      if (plugin.pluginMenu && plugin.isEnabled) {
        const pluginMenuItem: MenuElement = {
          ...plugin.pluginMenu,
          parentid: parentId
        };
        pluginMenus.push(pluginMenuItem);
      }
    });
    return pluginMenus;
  }
}
